const LANDING_TEST_API = process.env.REACT_APP_LANDING_TEST_API_URL || '/api/landingtest';

export async function submitLandingTestForm({
  name,
  email,
  phone,
  service,
  budget,
  description,
  turnstileToken,
  honey = '',
}) {
  const response = await fetch(LANDING_TEST_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name,
      email,
      phone,
      service,
      budget,
      description,
      turnstileToken,
      _honey: honey,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Impossibile inviare la richiesta. Riprova.');
  }

  return data;
}
